import { LocalizationProvider } from '@mui/lab';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import DateRangePicker, { DateRange } from '@mui/lab/DateRangePicker';
import { Button, InputAdornment, Stack, SvgIcon, TextField } from '@mui/material';
import { TextFieldProps } from '@mui/material/TextField/TextField';
import { Box } from '@mui/system';
import clsx from 'clsx';
import { format } from 'date-fns';
import { map } from 'lodash';
import { ChangeEvent, ComponentType, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Icons } from 'src/components/icons';
import { ApplicationStatus } from 'src/enums/application-status.enum';
import { DMYtoMDY, useRouter } from 'src/hooks';
import useStyles from './styles';

const navItems = [
  {
    labelKey: 'applications.new',
    label: 'Новые заявки',
    status: ApplicationStatus.PENDING,
  },
  {
    labelKey: 'applications.rejected_for_review',
    label: 'Новые заявки',
    status: ApplicationStatus.REJECTED_FOR_REVIEW,
  },
  {
    labelKey: 'applications.application_for_reconsideration',
    label: 'Новые заявки',
    status: ApplicationStatus.APPLICATION_FOR_RECONSIDERATION,
  },
  {
    labelKey: 'applications.permission_to_payment',
    label: 'Новые заявки',
    status: ApplicationStatus.PERMISSION_TO_PAYMENT,
  },
  // {
  //   labelKey: 'applications.rejected_due_to_non_implementation',
  //   label: 'Новые заявки',
  //   status: ApplicationStatus.REJECTED_DUE_TO_NON_IMPLEMENTATION,
  // },
  {
    labelKey: 'applications.payment_done',
    label: 'Новые заявки',
    status: ApplicationStatus.PAYMENT_DONE,
  },

  {
    labelKey: 'applications.confirmed',
    label: 'Одобренные заявки',
    status: ApplicationStatus.CONFIRMED,
  },
  {
    labelKey: 'applications.declined',
    label: 'Отклоненные заявки',
    status: ApplicationStatus.DECLINED,
  },
];

interface ApplicationsPanelProps {
  query: Record<string, any>;
  onUpdate: (x: Record<string, any>) => void;
  SearchFieldProps?: TextFieldProps;
}
export const ApplicationsPanel: ComponentType<ApplicationsPanelProps> = ({
  query,
  onUpdate,
  SearchFieldProps = {},
}) => {
  const router = useRouter();
  const classes = useStyles();
  const { t } = useTranslation();

  const [search, setSearch] = useState(query.search || '');
  const [dates, setDates] = useState<DateRange<Date>>([
    (query.createdAtFrom && new Date(DMYtoMDY(query.createdAtFrom))) || null,
    (query.createdAtTo && new Date(DMYtoMDY(query.createdAtTo))) || null,
  ]);
  const status = query.status || ApplicationStatus.PENDING;

  const handleSubmit = () => {
    const newParamsObject = {
      search,
      createdAtFrom: dates[0] && format(dates[0], 'yyyy-MM-dd'),
      createdAtTo: dates[1] && format(dates[1], 'yyyy-MM-dd'),
      page: 1,
    };
    onUpdate(newParamsObject);
  };

  return (
    <Box className={classes.root}>
      {/* top */}
      <Stack direction="row" justifyContent="space-between" alignItems="flex-end" mb={3}>
        {/* top - search */}
        <Stack direction="row" alignItems="flex-end" spacing={3}>
          <TextField
            label={t('action.search.by.applications', 'Поиск по заявкам')}
            {...SearchFieldProps}
            value={search}
            size="small"
            sx={{ width: 350 }}
            onChange={(e: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) =>
              setSearch(e.target.value)
            }
            InputProps={{
              startAdornment: (
                <SvgIcon component={Icons.Search} viewBox="0 0 24 24" color="primary" />
              ),
            }}
          />
          {router.pathname !== '/cabinet/certificates' ? (
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <DateRangePicker
                startText={t('periodFrom', 'Период с')}
                endText={t('periodTo', 'Период до')}
                value={dates}
                inputFormat="dd.MM.yyyy"
                mask=""
                onChange={(newValue) => {
                  setDates(newValue);
                }}
                renderInput={(startProps, endProps) => (
                  <Stack direction="row" alignItems="flex-end" spacing={3}>
                    <TextField
                      {...startProps}
                      size="small"
                      sx={{ width: 130 }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <Icons.Dropdown />
                          </InputAdornment>
                        ),
                      }}
                    />
                    <TextField
                      {...endProps}
                      size="small"
                      sx={{ width: 130 }}
                      InputProps={{
                        placeholder: 'dd.mm.yyyy',
                        readOnly: true,
                        endAdornment: (
                          <InputAdornment position="end">
                            <Icons.Dropdown />
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Stack>
                )}
              />
            </LocalizationProvider>
          ) : null}

          <Button variant="contained" color="secondary" type="submit" onClick={handleSubmit}>
            {t('action.search', 'Найти')}
          </Button>
        </Stack>

        {/* <Button variant="contained" color="secondary" endIcon={<Icons.Download />} size="small">
          {t('action.download.report', 'Скачать отчёт')}
        </Button> */}
      </Stack>

      {/* nav */}
      {router.pathname !== '/cabinet/certificates' ? (
        <Stack spacing={1} direction="row" mb={3}>
          {map(navItems, (item, index) => (
            <Button
              key={index}
              variant={status === item.status ? 'contained' : 'outlined'}
              color="primary"
              size="small"
              className={clsx(classes.navBtn, { [classes.activeNavBtn]: false })}
              onClick={() => onUpdate({ status: item.status, page: 1 })}
            >
              {t(item.labelKey, item.label)}
            </Button>
          ))}
        </Stack>
      ) : null}
    </Box>
  );
};
